import { defineMessages, useIntl } from 'react-intl';

export interface DeviceChoicesType {
  name: string;
  value: string;
}

const useDropDownChoices = () => {
  const intl = useIntl();

  const categoryChoices = [
    intl.formatMessage(messages.technicalIssues), // Technical Issues
    intl.formatMessage(messages.accountInformation), // Account Information
    intl.formatMessage(messages.billing), // Payments/Subscription
    intl.formatMessage(messages.siteFeature), // Site Feature
    intl.formatMessage(messages.resignation), // Resignation
    intl.formatMessage(messages.reportAMember), // Reporting Suspicious User
    intl.formatMessage(messages.other), // Other
  ];

  const deviceChoices: DeviceChoicesType[] = [
    {
      name: intl.formatMessage(messages.iosApp),
      value: `ios_app`,
    },
    {
      name: intl.formatMessage(messages.androidApp),
      value: `android_app`,
    },
    {
      name: intl.formatMessage(messages.mobileDevice),
      value: `mobile`,
    },
    {
      name: intl.formatMessage(messages.desktopDevice),
      value: `desktop`,
    },
  ];

  const operatingSystemChoices = [
    intl.formatMessage(messages.macos),
    intl.formatMessage(messages.windows),
    intl.formatMessage(messages.linux),
  ];

  const supportedBrowsersChoices = [
    intl.formatMessage(messages.chrome),
    intl.formatMessage(messages.firefox),
    intl.formatMessage(messages.safari),
    intl.formatMessage(messages.opera),
    intl.formatMessage(messages.android),
    intl.formatMessage(messages.iphone),
    intl.formatMessage(messages.edge),
    intl.formatMessage(messages.internetExplorer),
  ];

  return {
    categoryChoices,
    deviceChoices,
    operatingSystemChoices,
    supportedBrowsersChoices,
  };
};

export default useDropDownChoices;

const messages = defineMessages({
  iosApp: {
    id: 'src/modules/hooks/useDropDownChoices:iosApp',
    description: 'dropdown selection for iOS App',
    defaultMessage: 'iOS App',
  },
  androidApp: {
    id: 'src/modules/hooks/useDropDownChoices:androidApp',
    description: 'dropdown selection for Android App',
    defaultMessage: 'Android App',
  },
  mobileDevice: {
    id: 'src/modules/hooks/useDropDownChoices:mobileDevice',
    description: 'dropdown selection for mobile device',
    defaultMessage: 'Mobile',
  },
  desktopDevice: {
    id: 'src/modules/hooks/useDropDownChoices:desktopDevice',
    description: 'dropdown selection for desktop device',
    defaultMessage: 'Desktop',
  },
  chrome: {
    id: 'src/modules/hooks/useDropDownChoices:chrome',
    description: 'dropdown selection for Chrome browser',
    defaultMessage: 'Chrome',
  },
  safari: {
    id: 'src/modules/hooks/useDropDownChoices:safari',
    description: 'dropdown selection for Safari browser',
    defaultMessage: 'Safari',
  },
  firefox: {
    id: 'src/modules/hooks/useDropDownChoices:firefox',
    description: 'dropdown selection for Firefox browser',
    defaultMessage: 'Firefox',
  },
  opera: {
    id: 'src/modules/hooks/useDropDownChoices:opera',
    description: 'dropdown selection for Opera browser',
    defaultMessage: 'Opera',
  },
  android: {
    id: 'src/modules/hooks/useDropDownChoices:android',
    description: 'dropdown selection for Android browser',
    defaultMessage: 'Android',
  },
  iphone: {
    id: 'src/modules/hooks/useDropDownChoices:iphone',
    description: 'dropdown selection for iPhone browser',
    defaultMessage: 'iPhone',
  },
  edge: {
    id: 'src/modules/hooks/useDropDownChoices:edge',
    description: 'dropdown selection for Edge browser',
    defaultMessage: 'Edge',
  },
  internetExplorer: {
    id: 'src/modules/hooks/useDropDownChoices:internetExplorer',
    description: 'dropdown selection for Internet Explorer browser',
    defaultMessage: 'Internet Explorer',
  },
  macos: {
    id: 'src/modules/hooks/useDropDownChoices:macos',
    description: 'dropdown selection for MacOS (operating system)',
    defaultMessage: 'MacOS',
  },
  windows: {
    id: 'src/modules/hooks/useDropDownChoices:windows',
    description: 'dropdown selection for Windows (operating system)',
    defaultMessage: 'Windows',
  },
  linux: {
    id: 'src/modules/hooks/useDropDownChoices:linux',
    description: 'dropdown selection for Linux (operating system)',
    defaultMessage: 'Linux',
  },
  technicalIssues: {
    id: 'src/modules/hooks/useDropDownChoices:technicalIssues',
    description: 'dropdown selection for Technical Issues',
    defaultMessage: 'Technical Issues',
  },
  accountInformation: {
    id: 'src/modules/hooks/useDropDownChoices:accountInformation',
    description: 'dropdown selection for Account Information',
    defaultMessage: 'Account Information',
  },
  billing: {
    id: 'src/modules/hooks/useDropDownChoices:billing',
    description: 'dropdown selection for Billing',
    defaultMessage: 'Payments/Subscription',
  },
  siteFeature: {
    id: 'src/modules/hooks/useDropDownChoices:siteFeature',
    description: 'dropdown selection for Site Feature',
    defaultMessage: 'Site Feature',
  },
  resignation: {
    id: 'src/modules/hooks/useDropDownChoices:resignation',
    description: 'dropdown selection for Resignation',
    defaultMessage: 'Resignation',
  },
  reportAMember: {
    id: 'src/modules/hooks/useDropDownChoices:reportAMember',
    description: 'dropdown selection for Reporting Suspicious User',
    defaultMessage: 'Reporting Suspicious User',
  },
  other: {
    id: 'src/modules/hooks/useDropDownChoices:other',
    description: 'dropdown selection for Other',
    defaultMessage: 'Other',
  },
});
